var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "15", viewBox: "0 0 15 15", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.528 7.257a.464.464 0 0 0-.471.456c0 2.596-2.232 5.375-5.557 5.375s-5.557-2.78-5.557-5.375S4.175 2.34 7.5 2.34c1.831 0 3.318.921 4.224 1.89L9.386 4.18a.476.476 0 0 0-.413.22.443.443 0 0 0-.01.456.474.474 0 0 0 .403.236l3.36.07a.462.462 0 0 0 .345-.134.448.448 0 0 0 .138-.331l-.07-3.25A.465.465 0 0 0 12.657 1a.463.463 0 0 0-.462.466l.043 1.955A6.723 6.723 0 0 0 7.5 1.427c-3.887 0-6.5 3.25-6.5 6.286C1 10.75 3.613 14 7.5 14S14 10.75 14 7.713a.464.464 0 0 0-.472-.456z", fill: "#D7D7D7", fillRule: "nonzero", stroke: "#D7D7D7", strokeWidth: ".9" })
  );
});